export function NotFound() {
    return <h1>The requested page wasn't found</h1>
}
